import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class FollowUpsService {
    private followUpClickedSubject = new Subject<string>();
    public followUpClicked$ = this.followUpClickedSubject.asObservable();

    emitFollowUpClick(question: string) {
        this.followUpClickedSubject.next(question);
    }
}
